import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import AuditLogMaintenanceCont from "presentation/view/container/AuditLog/AuditLogMaintenanceCont";

CommonEntrypoint(<AuditLogMaintenanceCont />)